import { BaseModelJson } from "common/interfaces/BaseModelJson";
import BaseModel from "./BaseModel";
import { FilterImage, ImageJson } from "features/comment/types/gallery.type";

class ImageModel extends BaseModel implements BaseModelJson<ImageJson> {
  company_id: number;
  creator_id: number;
  id: number;
  directory_id: number;
  object_type: number;
  object_id: number;
  md5_hash: string;
  file_path: string;
  width: number;
  height: number;
  randomcode: string;
  title: string;
  description: string;
  extension: string;
  size_in_byte: number;
  origin: string;
  status: number;
  is_directory: number;
  ip_address: string;
  date_created: number;
  date_modified: number;
  url: string;

  constructor(json: ImageJson) {
    super();
    this.company_id = json.company_id || 0;
    this.creator_id = json.creator_id || 0;
    this.id = json.id || 0;
    this.directory_id = json.directory_id || 0;
    this.object_type = json.object_type || 0;
    this.object_id = json.object_id || 0;
    this.md5_hash = json.md5_hash || "";
    this.file_path = json.file_path || "";
    this.width = json.width || 0;
    this.height = json.height || 0;
    this.randomcode = json.randomcode || "";
    this.title = json.title || "";
    this.description = json.description || "";
    this.extension = json.extension || "";
    this.size_in_byte = json.size_in_byte || 0;
    this.origin = json.origin || "";
    this.status = json.status || 0;
    this.is_directory = json.is_directory || 0;
    this.ip_address = json.ip_address || "";
    this.date_created = json.date_created || 0;
    this.date_modified = json.date_modified || 0;
    this.url = json.url || "";
  }

  static getDefaultFilter(): FilterImage {
    return {
      page: 1,
      limit: 5,
      sort_by: "",
      sort_type: "",
      keyword: "",
      status: 0,
      item_id: "",
      item_type: "",
    };
  }

  toJson(): ImageJson {
    return {
      company_id: this.company_id,
      creator_id: this.creator_id,
      id: this.id,
      directory_id: this.directory_id,
      object_type: this.object_type,
      object_id: this.object_id,
      md5_hash: this.md5_hash,
      file_path: this.file_path,
      width: this.width,
      height: this.height,
      randomcode: this.randomcode,
      title: this.title,
      description: this.description,
      extension: this.extension,
      size_in_byte: this.size_in_byte,
      origin: this.origin,
      status: this.status,
      is_directory: this.is_directory,
      ip_address: this.ip_address,
      date_created: this.date_created,
      date_modified: this.date_modified,
      url: this.url,
    };
  }
}

export default ImageModel;
